import React, { useEffect } from "react";
import { reactIcons } from "../../utils/icons";
import { useAccount, useDisconnect } from "wagmi";
import { useAppKit } from "@reown/appkit/react";
import { useNavigate } from "react-router-dom";

const WalletLogin = () => {
  const { address, isConnected } = useAccount();
  const { disconnect } = useDisconnect();
  const { open } = useAppKit();
  const navigate = useNavigate();

  useEffect(() => {
    if (isConnected) {
      localStorage.setItem("daoWalletAddress", address);
    } else {
      localStorage.removeItem("daoWalletAddress");
    }
  }, [isConnected]);

  const daoWalletAddress = localStorage.getItem("daoWalletAddress");
  useEffect(() => {
    if (!daoWalletAddress) {
      disconnect();
    }
  }, [daoWalletAddress]);

  useEffect(() => {
    if (address && isConnected) {
      navigate("/portal/dao");
    }
  }, [address, isConnected]);

  useEffect(() => {
    disconnect();
  }, []);

  return (
    <>
      <div className="text-white min-h-screen flex flex-col items-center justify-start pt-5 md:pt-10 px-4 overflow-auto">
        <h1 className="text-3xl mt-6 md:mt-8 md:text-5xl text-white font-bold text-center mb-5">
          My voting power
        </h1>
        <p className="text-center text-sm md:text-lg mb-2">
          To Become a DAO member, a minimum of{" "}
          <span className="text-[#ee0000]">200</span> MSTC token is required
        </p>
        <p className="text-center text-sm md:text-lg mb-6">
          Connect your wallet to see your voting power and start delegating
        </p>
        <div className="flex gap-2 md:gap-3  justify-center items-center">
          <button
            onClick={async () => {
              if (!isConnected) {
                await open();
              } else {
                disconnect();
              }
            }}
            className="flex items-center gap-2 px-4 md:px-6 py-2 rounded-full w-[220px]  md:w-[240px]  justify-center border border-red-600 button-gradient-bg text-white font-semibold shadow-md transition"
          >
            {isConnected ? "Disconnect Wallet" : "Connect Wallet"}{" "}
            {isConnected ? reactIcons.disconnect : reactIcons.walletArrow}
          </button>
        </div>

        <div className="mt-20 md:mt-10  w-full h-full hidden md:flex items-end justify-center px-0 md:px-4">
          <img
            loading="lazy"
            src="/wallet-login-bg.png"
            alt="Dashboard Preview"
            className="w-full  rounded-lg max-w-[980px] shadow-lg"
          />
        </div>
        <div className="mt-10 md:mt-10 w-full h-full  md:hidden flex items-end justify-center px-0 md:px-4">
          <img
            loading="lazy"
            src="/wallet-login-mob-bg.png"
            alt="Dashboard Preview"
            className="w-full  rounded-lg max-w-[600px] shadow-lg"
          />
        </div>
      </div>
    </>
  );
};

export default WalletLogin;
